// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ThemeTask_wrapper__3_tQs","wrapperContent":"ThemeTask_wrapperContent__3VBOQ"};